import { render, staticRenderFns } from "./seriesGrid.vue?vue&type=template&id=676b586a&scoped=true&"
import script from "./seriesGrid.vue?vue&type=script&lang=js&"
export * from "./seriesGrid.vue?vue&type=script&lang=js&"
import style0 from "./seriesGrid.vue?vue&type=style&index=0&lang=css&"
import style1 from "./seriesGrid.vue?vue&type=style&index=1&id=676b586a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676b586a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('676b586a', component.options)
    } else {
      api.reload('676b586a', component.options)
    }
    module.hot.accept("./seriesGrid.vue?vue&type=template&id=676b586a&scoped=true&", function () {
      api.rerender('676b586a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\series\\seriesGrid.vue"
export default component.exports